import React, { forwardRef, ReactNode, Suspense } from "react";
import { Spinner } from "reactstrap";

const ContentSlide = forwardRef<HTMLDivElement, { children: ReactNode }>(
  function ContentSlideRender({ children }, ref) {
    return (
      <div className="content-slide slide-content" ref={ref}>
        <Suspense
          fallback={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh"
              }}
            >
              <Spinner />
            </div>
          }
        >
          {children}
        </Suspense>
      </div>
    );
  }
);

export default ContentSlide;
